<div class="flex flex-col gap-[2rem] sm:min-w-[45rem] sm:max-w-[45rem]">
    <form #vacuForm="ngForm" class="flex w-full" 
    [ngClass]="{'pr-[1rem]': ((notRegistredUser || recurringTerm) && !showingRecurringTerms) || windowDimensions.height <= windowDimensions.threshold_md}">

        <div class="flex flex-col gap-[3rem] w-full h-full popup-anim" *ngIf="!showingRecurringTerms">
            <!-- Base info select-->
            <div class="flex flex-col gap-[1rem] w-full mb-[-1rem]">
                <div class="flex flex-col gap-1 w-full">
                    <mat-label>{{"Select type of service" | translate}}</mat-label>
                    <mat-form-field appearance="outline" >
                        <mat-icon matPrefix><i class="fa-regular fa-spa text-[2rem] pr-[1rem]"></i></mat-icon>
                        <mat-select [(ngModel)]="dailyAvailabilityArgsForDays.serviceId"  placeholder='{{"Select type of service" | translate}}' name="serviceType" #serviceType="ngModel" required
                        (selectionChange)="retrieveAllEpmloyeeByService()">
                            <mat-option *ngFor="let service of serviceData" [value]="service.id">
                                {{service.name}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="serviceType && serviceType.errors">
                            <span *ngIf="serviceType.errors['required']">{{"Required Field" | translate}}</span>
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="flex flex-col gap-1 w-full">
                    <mat-label>{{"Select employee" | translate}}</mat-label>
                    <mat-form-field appearance="outline" >
                        <mat-icon matPrefix><i class="fa-regular fa-square-user text-[2rem] pr-[1rem]"></i></mat-icon>
                        <mat-select [(ngModel)]="dailyAvailabilityArgsForDays.employeeProfileId" placeholder='{{"Select employee" | translate}}'
                            (ngModelChange)="resetDateTime()"
                            name="selectEmployee" #selectEmployee ="ngModel" required>
                            <mat-option *ngFor="let employee of employeeData" [value]="employee.profileId">
                                {{employee.name}} {{employee.surname}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="selectEmployee && selectEmployee.errors">
                            <span *ngIf="selectEmployee.errors['required']">{{"Required Field" | translate}}</span>
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <!-- User Select-->
            <div class="flex flex-col gap-[1rem]">
                <div class="w-full justify-start flex flex-row gap-5">
                    <label class="relative inline-flex items-center cursor-pointer">
                        <input #toggle type="checkbox"
                        [value]="notRegistredUser"
                        [checked]="notRegistredUser"
                        (change)="notRegistredUser = !notRegistredUser;"
                        class="sr-only peer">
                        <div
                            class="w-[3rem] h-[1.65rem] bg-gray-200 peer-focus:outline-none
                            peer-focus:ring-2 peer-focus:ring-[rgba(255,255,255,0.15)] rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-[#2c99b1]"></div>
                    </label>

                    <p class="font-normal text-[1.3rem] select-none"
                    (click)="notRegistredUser = !notRegistredUser"> {{"Not registered user" | translate}}
                    </p>
                </div>

                <div class="flex flex-col gap-1 w-full" *ngIf="!notRegistredUser">
                    <div class="flex flex-col gap-1 w-full">
                        <mat-label>{{"Select a client" | translate}}</mat-label>
                        <mat-form-field appearance="outline"
                                *ngIf="notRegistredUser===false">
                                <mat-icon matPrefix><i class="fa-regular fa-user text-[2rem] pr-[1rem]"></i></mat-icon>
                                <mat-select placeholder='{{"Select a client" | translate}}' #client="ngModel" name="client" [(ngModel)]="clientProfileId" required>
                                    <mat-option *ngFor="let client of clientsData"  [value]="client.profileId">
                                        {{client.name}} {{client.surname}}
                                    </mat-option>
                                    <mat-option *ngIf="clientsData?.length === 0">
                                        {{"Not found clients" | translate}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="client && client.errors">
                                    <span *ngIf="client.errors['required']">{{"Required Field" | translate}}</span>
                                </mat-error>
                        </mat-form-field>
                    </div>
                </div>    

                <div class="flex flex-col gap-[1rem]" *ngIf="notRegistredUser">
                    <div class="flex flex-col gap-1 w-full">
                        <mat-form-field appearance="outline" class="mr-1">
                            <mat-label>{{"name" | translate}}</mat-label>
                            <mat-icon matPrefix><i class="fa-regular fa-user text-[2rem] pr-[1rem]"></i></mat-icon>
                            <input type="text" matInput name="nameUser" #nameUser="ngModel"
                                [(ngModel)]="addBookingData.name" required />
                            <mat-error *ngIf="nameUser && nameUser.errors">
                                <span *ngIf="nameUser.errors['required']">{{"Required Field" | translate}}</span>
                                <span *ngIf="nameUser.errors['minlength']">{{"Required minimum 3 caracters" | translate}}</span>
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="flex flex-col gap-1 w-full">
                        <mat-form-field appearance="outline">
                            <mat-label>{{"surname" | translate}}</mat-label>
                            <mat-icon matPrefix><i class="fa-regular fa-user text-[2rem] pr-[1rem]"></i></mat-icon>
                            <input type="text" matInput name="surnameUser" #surnameUser="ngModel"
                                [(ngModel)]="addBookingData.surname" required />
                            <mat-error *ngIf="surnameUser && surnameUser.errors">
                                <span *ngIf="surnameUser.errors['required']">{{"Required Field" | translate}}</span>
                                <span *ngIf="surnameUser.errors['minlength']">{{"Required minimum 3 caracters" | translate}}</span>
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="flex flex-col gap-1 w-full">
                        <mat-form-field appearance="outline" >
                            <mat-label>{{"primaryEmail" | translate}}</mat-label>
                            <input type="email" matInput name="emailUser" #emailUser="ngModel" [(ngModel)]="addBookingData.email"
                                required />
                            <mat-error *ngIf="emailUser && emailUser.errors">
                                <span *ngIf="emailUser.errors['required']">{{"Required Field" | translate}}</span>
                                <span *ngIf="emailUser.errors['minlength']">{{"Required minimum 3 caracters" | translate}}</span>
                                <span *ngIf="emailUser.errors['email']">{{"Email must be a valid email address" | translate}}</span>
                            </mat-error>
        
                            <mat-icon matPrefix><i class="fa-regular fa-at text-[2rem] pr-[1rem]"></i></mat-icon>
                        </mat-form-field>
                    </div>

                    <div class="flex flex-col gap-1 w-full">
                        <mat-form-field appearance="outline">
                            <mat-label>{{"primaryPhoneNumber" | translate}}</mat-label>
                            <mat-icon matPrefix><i class="fa-regular fa-phone-volume text-[2rem] pr-[1rem]"></i></mat-icon>
                            <input type="text" matInput name="phoneUser" pattern="^([0-9][0-9]*)$" #phoneUser="ngModel" [(ngModel)]="addBookingData.phone"
                                required />
                            <mat-error *ngIf="phoneUser && phoneUser.errors">
                                <span *ngIf="phoneUser.errors['required']">{{"Required Field" | translate}}</span>
                                <span *ngIf="phoneUser.errors['minlength']">{{"Required minimum 3 caracters" | translate}}</span>
                                <span *ngIf="phoneUser.errors['pattern']">{{"Allowed only numbers" | translate}}</span>
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <!-- Term(s) Info Select-->
            <div class="flex flex-col gap-[1rem]">
                <div class="w-full flex flex-col gap-[1rem]">
                    <div class="w-full justify-start flex flex-row gap-5 mt-[-1rem]">
                        <label class="relative inline-flex items-center cursor-pointer">
                            <input #toggle type="checkbox"
                            [value]="recurringTerm"
                            [checked]="recurringTerm"
                            (change)="recurringTerm = !recurringTerm;"
                            class="sr-only peer">
                            <div
                                class="w-[3rem] h-[1.65rem] bg-gray-200 peer-focus:outline-none
                                peer-focus:ring-2 peer-focus:ring-[rgba(255,255,255,0.15)] rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-[#2c99b1]"></div>
                        </label>
    
                        <p class="font-normal text-[1.3rem] select-none"
                        (click)="recurringTerm = !recurringTerm"> {{"A recurring term" | translate}}
                        </p>
                    </div>

                    <div class="flex flex-col gap-1 w-full">
                        <mat-form-field  appearance="outline">
                            <mat-icon matPrefix><i class="fa-regular fa-calendar text-[2rem] pr-[1rem]"></i></mat-icon>
                            <input matInput [matDatepicker]="picker" [(ngModel)]="dailyAvailabilityArgsForDays.startDate" (dateChange)="retriveHours()"
                                [min]="yesterday" placeholder='{{"Select a date" | translate}}' #date="ngModel"
                                name="date" [matDatepickerFilter]="combinedFilter" required>
                            <mat-hint>{{"MM/DD/YYYY" | translate}}</mat-hint>
                            <mat-datepicker-toggle matSuffix [for]="picker" ></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                            <mat-error *ngIf="date && date.errors">
                                <span *ngIf="date.errors['required']">{{"The field is required" | translate }}.</span>
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="flex flex-col gap-1 w-full">
                        <mat-label>{{"Select a time" | translate}}</mat-label>
                        <mat-form-field appearance="outline" >
                            <mat-icon matPrefix><i class="fa-regular fa-clock text-[2rem] pr-[1rem]"></i></mat-icon>
                            <mat-select placeholder='{{"Select a time" | translate}}' [(ngModel)]="hourSelection" #termHour="ngModel" name="termHour">
                                <mat-option *ngIf="termHourlyData?.length === 0">
                                    {{"No terms found for this employee today" | translate}}
                                </mat-option>

                                <mat-option  *ngFor="let termHour of termHourlyData" [value]="termHour">
                                    {{termHour | date:'HH:mm'}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="termHour && termHour.errors">
                                <span *ngIf="termHour.errors['required']">{{"Required Field" | translate}}</span>
                            </mat-error>
                        </mat-form-field>
                    </div>  

                    <div *ngIf="recurringTerm===true" class="flex flex-col pr-[1rem]">
                        <div class="flex flex-col gap-1 w-full">
                            <mat-form-field appearance="outline" >
                                <mat-label>{{"Number of repeat" | translate}}</mat-label>
                                <mat-icon matPrefix><i class="fa-regular fa-repeat text-[2rem] pr-[1rem] "></i></mat-icon>
                                <input type="number" matInput name="numberOfRepeat" [min]="0" #numberOfRepeat="ngModel" maxlength="2"
                                    [(ngModel)]="numberOfAppointments" required />
                                <mat-error *ngIf="numberOfRepeat && numberOfRepeat.errors">
                                <span *ngIf="numberOfRepeat.errors['required']">{{"Required Field" | translate}}</span>
                                <span *ngIf="numberOfRepeat.errors['maxlength']">{{"Required maximum 2 numbers" | translate}}</span>
                            </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="flex flex-col gap-1 w-full">
                            <mat-label>{{"Generate term of every" | translate}}:</mat-label><br>                        
                            <div class="flex flex-row justify-between gap-3 w-full">
                                <mat-form-field appearance="outline"  class="w-1/2 mr-1">
                                    <mat-label>{{"select" | translate}}</mat-label>
                                    <mat-icon matPrefix><i class="fa-regular fa-calendar-range text-[2rem] pr-[1rem] "></i></mat-icon>
                                    <mat-select name="generateTermOfEvery" [(ngModel)]="daysNumber">
                                        <mat-option *ngFor="let num of numberOfDays" [value]="num">
                                            {{ num }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
    
                                <mat-form-field appearance="outline" class="w-1/2">
                                    <mat-label>{{"select" | translate}}</mat-label>
                                    <mat-icon matPrefix><i class="fa-regular fa-calendar-plus text-[2rem] pr-[1rem] "></i></mat-icon>
                                    <mat-select name="days" [(ngModel)]="daysMultiplier">
                                        <mat-option [value]="1">
                                            {{"day" | translate}}
                                        </mat-option>
                                        <mat-option [value]="7">
                                            {{"week" | translate}}
                                        </mat-option>
                                        <mat-option [value]="30">
                                            {{"month" | translate}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                        
                    </div>
                </div>

                <div class="w-full h-full flex flex-col gap-[2rem] justify-between align-middle items-center mt-[-1rem]" *ngIf="recurringTerm === true">
                    <button type="button" class="flex flex-col justify-center w-max" [disabled]="!vacuForm.valid"
                        mat-raised-button color="primary" (click)="retrieveGeneratedTimeSlots()">
                        {{"Generate terms" | translate}}
                    </button>

                    <mat-divider class="w-full mt-[1rem]"> </mat-divider>
                </div>
            </div>
        </div>

        <div class="flex flex-col gap-[1rem] popup-anim w-full" *ngIf="showingRecurringTerms">
            <div *ngFor="let term of termDataList; index as i" class="w-full">
                <div id="checklist" class="w-full">
                    <input [id]="i" type="checkbox" name="r" value=i [disabled]="term.unavailableTerm===true || term.unavailableEmployee===true" (change)="addTermToBooking(term)">
                    <label [for]="i" class="font-normal w-full" [ngClass]="{'text-decoration: line-through': term.unavailableTerm===true || term.unavailableEmployee===true}">
                        {{ term.fromDate | date:'dd.MM.yyyy' }}, {{translate("DaysOfWeekFull." + (term.fromDate!.getDay() + 1).toString())}} {{ term.fromDate | date:'HH:mm' }}
                    </label>
                </div>

                <button 
                    [disabled]="term.alternativeTermDataList!.length > 0" 
                    *ngIf="term.unavailableTerm===true && !term.unavailableEmployee" 
                    (click)="retriveAlternateTermHours(term, i)" 
                    class="bg-secondary px-[.75rem] py-[.65rem] rounded-xl flex justify-center my-[.35rem] align-middle self-center" 
                    [ngClass]="{'opacity-100': !(term.alternativeTermDataList!.length > 0), 'opacity-20': term.alternativeTermDataList!.length > 0}">
                    <p class="text-white uppercase text-[0.75rem]"> {{"Create alternative terms" | translate}} </p>
                </button>
                
                <div *ngIf="term.unavailableEmployee===true" class="bg-[#F9DEC0] rounded-md p-3 flex flex-row justify-between align-middle items-center gap-3 text-[#D94E4E] ml-3">
                    <div class="text-[1.25rem]"> {{"No alternative terms for this day" | translate}} </div>
                </div>

                <div *ngFor="let alternativeTerm of term.alternativeTermDataList; index as j">
                    <div class="alternativeAviabilityTerm">
                        <div id="checklist">
                            <input [id]=j+((i+1)*100) type="checkbox" name="r" value=j+((i+1)*100) (change)="addTermToBooking(alternativeTerm)">
                            <label [for]=j+((i+1)*100) class="font-normal">
                                {{ alternativeTerm.fromDate | date:'dd.MM.yyyy' }},  {{translate("DaysOfWeek." + (alternativeTerm.fromDate!.getDay() + 1).toString())}} {{ alternativeTerm.fromDate | date:'HH:mm' }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </form>

    <div [class.alternative-css-btn]="showingRecurringTerms" class="flex flex-row gap-10 text-[1rem] sm:text-[1.35rem]">
        <button (click)="!showingRecurringTerms ? closePopup() : (showingRecurringTerms = !showingRecurringTerms); $event.preventDefault();" type="button"
        class="w-1/2 px-5 py-[.5rem] rounded-[.25rem] uppercase bg-[#dadada] text-[#696767] hover:bg-[#c4c4c4] shadow-md active:scale-[0.985] active:shadow-sm">
        {{"back" | translate}}
        </button>

        <button [disabled]="!vacuForm" [ngClass]="{
            'bg-[#b98d78] hover:bg-[#a57d6a] ': vacuForm,
            'bg-[#b98d78]/20 hover:bg-[#a57d6a]/20': !vacuForm
            }" (click)="addBooking()" class="w-1/2 uppercase px-5 py-[.5rem] rounded-[.25rem] text-white shadow-md active:scale-[0.985] active:shadow-sm">
        {{"Add term" | translate}}
        </button>
    </div>

</div>

